<svelte:head>
  <title>Needs| A Good Thing</title>
</svelte:head>

{#if items && items.length === 0}
  <h3 class="px-4">No needs have been created</h3>
{:else if items && items.length > 0}
  <table class="table is-fullwidth is-hoverable">
    <thead />
    <tbody>
      {#each items as item}
        <tr>
          {#if item.data}
            <td>
              <div
                class="is-pulled-left"
                style="width=120px; margin-right:20px;">
                <a
                  href={$url('../../need/' + item.id)}
                  style="display:inline-block;width:120px;">
                  {#if item.data.images?.[0]}
                    <img
                      alt="Offer"
                      src={item.data.images[0]}
                      style="max-height:120px;max-width:120px;" />
                  {:else}
                    <img
                      alt="Generic"
                      src="/assets/img/box.png"
                      style="height:120px;width:120px; background-color:#eee" />
                  {/if}
                </a>
              </div>
              <div class="-block">
                <a href={$url('../../../need/' + item.id)}>
                  {item.data.title}
                </a>
              </div>
              <div class="-block">{item.data.needs}</div>
            </td>
            <td />
          {/if}
        </tr>
      {/each}
    </tbody>
  </table>
{/if}

<script lang="ts">
  import { url, params } from '@sveltech/routify';

  let charityId = $params['id'];

  let firebase = window.firebase;

  let items: Need_v1_Doc[] = [];

  getNeeds();

  async function getNeeds() {
    firebase
      .firestore()
      .collection('needs_v1')
      .where('charity', '==', charityId)
      .onSnapshot((snap) => {
        items = snap.docs
          .map((doc) => ({ id: doc.id, data: doc.data() } as Need_v1_Doc))
          .sort((a, b) => (b.data.created > a.data.created ? 1 : -1));
      });
  }
</script>
